import { ROLES as R } from "../core/roles";
import { lud, rule } from "../core/rule";

export const ludPermissions = { view: "lud.view" };

export const ludGrants = {
  "lud.view": rule(lud(R.DM, R.DMM)),
};
